import { DosageDiaryProfileCardProps } from '../interface/interface';

export function DosageDiaryProfileCards({
  profiles,
  dosageDiarySelector,
}: DosageDiaryProfileCardProps) {
  function fetchStylesByActiveStatus(isActive: boolean) {
    return isActive
      ? 'text-green-700 bg-green-50 ring-green-600/20'
      : 'text-yellow-800 bg-yellow-50 ring-yellow-600/20';
  }

  return (
    <ul role="list" className="divide-y divide-gray-100">
      {profiles.map((profile, index) => (
        <li
          key={index}
          className="flex items-center justify-between gap-x-6 p-5"
        >
          <div className="min-w-0">
            <div className="flex items-start gap-x-3">
              <p className="text-sm/6 font-semibold text-gray-900">
                {profile.name}
              </p>
              <p
                className={`mt-0.5 whitespace-nowrap rounded-md px-1.5 py-0.5 text-xs font-medium ring-1 ring-inset
      ${fetchStylesByActiveStatus(profile.isActive)}`}
              >
                {profile.isActive ? 'Active' : 'Inactive'}
              </p>
            </div>
            <div className="mt-1 flex items-center gap-x-2 text-xs/5 text-gray-500">
              <p className="truncate">Created by {profile.createdBy}</p>
            </div>
          </div>
          <div className="flex flex-none items-center gap-x-4">
            <a
              href="#"
              onClick={() => dosageDiarySelector(profile)}
              className="hidden rounded-md bg-white px-2.5 py-1.5 
      text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:block"
            >
              View<span className="sr-only">, {profile.name}</span>
            </a>
          </div>
        </li>
      ))}
    </ul>
  );
}
